export const SIGN_OUT = '@auth/SIGN_OUT';
export const SIGN_IN = '@auth/SIGN_IN';
export const UPDATE_AUTH_INFO = '@auth/UPDATE_AUTH_INFO';